'use client';
import {Fragment, memo, useState} from 'react';
import dayjs from 'dayjs';
import {cn} from '@/app/utils/CN';
import CheckIcon from '@/components/icons/CheckIcon';

const services = [
  {
    title: 'NextJS || NuxtJS || Angular',
    items: [
      {name: 'Input field'},
      {name: 'Select component'},
      {name: 'Autocomplete component'},
      {name: 'Datepicker component'},
      {name: 'Gallery preview component'},
      {name: 'PDF Preview component'},
    ],
  },
  {
    title: 'Payments',
    items: [
      {name: 'Checkout sessions'},
      {name: 'Handle webhooks'},
      {name: 'Tip to setup your account'},
    ],
  },
  {
    title: 'SEO',
    items: [
      {name: 'Meta tags to rank on Google'},
      {name: 'SEO-optimized UI components'},
      {name: 'Generated sitemap to fasten google indexing'},
    ],
  },
  {
    title: 'Style',
    items: [
      {name: 'Components'},
      {name: 'Animations'},
      {name: 'Sections'},
      {name: 'Responsive design'},
      {name: 'Dark mode'},
    ],
  },
  {
    title: 'More',
    items: [
      {name: 'Slack community'},
      {name: 'Copy-paste templates'},
      {name: 'More framework and libraries support'},
      {name: 'Lifetime update'},
    ],
  },
];

const Services = () => {
  const date = dayjs().add(15, 'minutes').format('HH:mm');
  const paused = dayjs().add(45, 'minutes').format('HH:mm');

  const [activeTab, setActiveTab] = useState(0);

  return (
    <section
      id={'services'}
      className={'pt-[100px]'}
    >
      <div className={'flex justify-center py-5'}>
        <div className={'w-full px-2 xl:px-0 xl:w-1/2'}>
          <p
            className={cn(
              'animate-pulse text-xl xl:text-xl font-serif',
              'text-primary dark:text-secondary'
            )}
          >
            const startBreak = &#39;<span className={'font-semibold font-mono'}>{date}</span>&#39;;
          </p>
          <p
            className={cn(
              'animate-pulse text-xl xl:text-xl font-serif',
              'text-primary dark:text-secondary'
            )}
          >
            const endBreak = &#39;<span className={'font-semibold font-mono'}>{paused}</span>&#39;;
          </p>
          <p
            className={cn(
              'text-2xl xl:text-5xl leading-snug font-mono',
              'text-primary dark:text-white'
            )}
          >
            Charge your app instantly, launch faster, launch easier, make €
          </p>
        </div>
      </div>
      <div
        className={cn('w-full flex flex-row gap-5 p-5', 'bg-primary-dark dark:bg-secondary-dark')}
      >
        <div className={'flex flex-col gap-5 w-full'}>
          {services.map((service, idx) => (
            <Fragment key={'service-' + idx}>
              <button
                onClick={() => setActiveTab(idx)}
                className={cn(
                  'p-2 rounded-full font-serif text-2xl xl:text-4xl',
                  'bg-secondary text-primary dark:bg-primary-dark dark:text-secondary-dark',
                  {
                    'font-extrabold dark:text-secondary': activeTab === idx,
                  }
                )}
              >
                {service.title}
              </button>
              <div className={'flex justify-center'}>
                <div
                  className={cn('transition-all ease-in-out', {
                    'duration-500 max-h-lvh': activeTab === idx,
                    'max-h-0 overflow-hidden': activeTab !== idx,
                  })}
                >
                  {service.items.map((item, idx) => (
                    <p
                      key={'item-' + idx}
                      className={cn(
                        'flex gap-2 text-lg xl:text-2xl',
                        'text-secondary dark:text-primary-dark'
                      )}
                    >
                      <CheckIcon className={'stroke-secondary dark:stroke-primary'} />
                      {item.name}
                    </p>
                  ))}
                </div>
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default memo(Services);
